// extracted by mini-css-extract-plugin
module.exports = {"reasonRemarks":"void-vip-transaction-history-modal_reasonRemarks__27fAS"};